import { Stack, Typography } from "@mui/material";
import { FieldConfigurationType } from "../../../../../shared/reporting/api/biClient.types";
import { MeasureDrillDownInfo } from "../../../../api/biApi.types";
import { DrillDownPage } from "../../../../store/types/drillDownPageState.types";
import { getCalculatedFieldTitle } from "./utils/getCalculatedFieldTitle";

interface Props {
  configuration: DrillDownPage;
  info: MeasureDrillDownInfo;
}

export default function PageTitle({ configuration, info }: Props) {
  const calculatedField = getCalculatedFieldTitle(info) + getFieldSubCaption(configuration);
  const measureCaption = getMeasureCaption(configuration);

  return (
    <Stack py={1.5} gap={0.3}>
      <Typography variant="h6">{measureCaption}</Typography>
      <Stack direction="row" gap={1}>
        {configuration.cell.formattedValue && (
          <Typography variant="caption" color="text.secondary">
            {configuration.cell.formattedValue}
          </Typography>
        )}
        {calculatedField && (
          <Typography variant="caption" color="text.secondary">
            {calculatedField}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}

function getMeasureCaption(configuration: DrillDownPage) {
  const caption = configuration.measure?.config.customLabel || configuration.measure?.meta.caption;
  return caption;
}
function getFieldSubCaption(configuration: DrillDownPage) {
  if (configuration.measure?.config.type === FieldConfigurationType.Irr) {
    return ` • ${configuration.measure?.config.cashFlowFrequency}`;
  }
  return "";
}
